import './styles.css';
import React from "react";

import profile from './resources/images/profile.jpg';

class ProfileContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        loaded: false
    }
}
isLoaded = () => {
    this.setState({
        loaded: true
    })
}
render() {
  return [
      <div key={1} className="profilePhoto">
        <div key={1} className="cover"></div>
        <div key={2} className={this.state.loaded? "hide": ""}></div>
        <img key={3} className={this.state.loaded? "": "hideBehind"} src={profile} alt="Brisbane City" onLoad={this.isLoaded}/>

      </div>
      
   ];
}
}
function AboutMe() {
  return [
    <div key={1} className="multiRow">
      <ProfileContainer key={1}></ProfileContainer>
      <article key={2} className="aboutMe">
          <p key={1} className="tabTitle custom">About Me</p>
          <div key={2} className="content">
            <section key={1}><p key={1}>I'm Franco Canalejo, a passionate self-taught junior web developer looking for new experiences and challenges.</p></section>
            <section key={2}><p key={1}>If you are looking for someone proactive, willing to learn, creative and with a good eye for design, then maybe...</p></section>
          </div>
          <section key={3} className="customPar"><p>I am</p> <p>who you've been</p> <p>looking for</p></section>
      </article>
    </div>
   ];
}

export default AboutMe;
